/* =============================================================================
=    Vehicle Models
============================================================================= */
import gql from 'graphql-tag';

export default gql`
  query vehicleModels {
    vehicleModels {
      id
      fullModelCode
      brand
      year
      region
      name
      model
      edition
      assetPath
      active
      vehicleMarketStatusDesc
      basePrice
      depositAmount
      preorderDepositAmount
      reserveSpotCap
      isWaitlistAllowed
      vehicleOverviewAssets {
        version
        locale
        title
        model
        edition
        expectAvailableDate
        coverImage {
          mobile
          tablet
          desktop
        }
        overviewFeatures {
          title
          description
        }
        overviewSpecs {
          title
          description
        }
      }
    }
  }
`;
